import { render, staticRenderFns } from "./polaris-text-field.vue?vue&type=template&id=107ab265&"
import script from "./polaris-text-field.vue?vue&type=script&lang=js&"
export * from "./polaris-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports